import {ReactElement} from "react"
import {Modal, ModalProps} from "antd"
import classNames from "classnames"
import {useStore} from "@ui/stores"

const PoolModal = ({className, ...rest}: ModalProps): ReactElement => {
  const {settings} = useStore()

  return <Modal
    className={classNames(className, "modal", `modal-${settings.deviceType}`)}
    {...rest}
  />
}

export default PoolModal
